import { render, staticRenderFns } from "./DataBackup.vue?vue&type=template&id=3ea2ac0f&"
import script from "./DataBackup.vue?vue&type=script&lang=js&"
export * from "./DataBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports